import React from "react";
import { InfrastructureApplication } from "@store/types";
import { State, getInfrastructureApplications } from "@store";
import { useSelector, useDispatch } from "react-redux";

type Data<T> = [T, Error | null, boolean];

export function useInfrastructureApplications(
  application_id: number
): Data<InfrastructureApplication[] | null> {
  const dispatch = useDispatch();
  const [
    infrastructure_applications,
    error,
    fetching,
  ] = useSelector((state: State) => [
    state.infrastructureApplications[application_id],
    state.network.error.infrastructureApplications[application_id],
    state.network.fetching.infrastructureApplications[application_id],
  ]);

  React.useEffect(() => {
    if (!infrastructure_applications && !fetching && !error) {
      dispatch(getInfrastructureApplications(application_id));
    }
  }, [application_id, dispatch, infrastructure_applications, error, fetching]);

  return [infrastructure_applications, error, fetching];
}
